var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 96",
    width: "16px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0h2v1c0,3.4,2.2,9,5.8,12.3l0.6,0.5l0.1,0.1c2,1.7,3.9,3.7,5.4,5.9c1.4,2.2,2.1,4.7,2.2,7.3l0,0v41c0.1,3-0.6,6-2.1,8.6 c-1.5,2.2-3.4,4.3-5.5,6l-0.1,0.1l-0.6,0.5C4.2,86.5,2,92.1,2,95.5V96H0V0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTab);
export default __webpack_public_path__ + "static/media/tab.3b63dfbe2639b463213a66c7282530a2.svg";
export { ForwardRef as ReactComponent };